import TWEEN from 'tween.js'
import * as THREE from 'three'
import { TextureManager } from './TextureManger'
import { CPointSet } from './CameraPoints'
import { config } from './config'
import { Renderer } from './Renderer'

class Material {
  constructor (textureRoot, pointSize) {
    this.textureMgr = new TextureManager()
    this.textureMgr.init(textureRoot, pointSize)

    this.cubeFaceCenter512 = [// 立方体六个面中心
      [1, 0, 0], [-1, 0, 0],
      [0, 1, 0], [0, -1, 0],
      [0, 0, -1], [0, 0, 1]]
    this.cubeFaceCenter1k = [// 立方体每个面4张照片的中心
      [[2, 1, -1], [2, -1, -1], [2, 1, 1], [2, -1, 1]],
      [[-2, 1, 1], [-2, -1, 1], [-2, 1, -1], [-2, -1, -1]],
      [[-1, 2, 1], [-1, 2, -1], [1, 2, 1], [1, 2, -1]],
      [[1, -2, 1], [1, -2, -1], [-1, -2, 1], [-1, -2, -1]],
      [[-1, 1, -2], [-1, -1, -2], [1, 1, -2], [1, -1, -2]],
      [[1, 1, 2], [1, -1, 2], [-1, 1, 2], [-1, -1, 2]]
    ]
    this.cubeFaceCenter2k = [// 立方体每个面16张照片的中心
      [[4, 3, -3], [4, 1, -3], [4, -1, -3], [4, -3, -3],
        [4, 3, -1], [4, 1, -1], [4, -1, -1], [4, -3, -1],
        [4, 3, 1], [4, 1, 1], [4, -1, 1], [4, -3, 1],
        [4, 3, 3], [4, 1, 3], [4, -1, 3], [4, -3, 3]],

      [[-4, 3, 3], [-4, 1, 3], [-4, -1, 3], [-4, -3, 3],
        [-4, 3, 1], [-4, 1, 1], [-4, -1, 1], [-4, -3, 1],
        [-4, 3, -1], [-4, 1, -1], [-4, -1, -1], [-4, -3, -1],
        [-4, 3, -3], [-4, 1, -3], [-4, -1, -3], [-4, -3, -3]], // 一个面

      [[-3, 4, 3], [-3, 4, 1], [-3, 4, -1], [-3, 4, -3],
        [-1, 4, 3], [-1, 4, 1], [-1, 4, -1], [-1, 4, -3],
        [1, 4, 3], [1, 4, 1], [1, 4, -1], [1, 4, -3],
        [3, 4, 3], [3, 4, 1], [3, 4, -1], [3, 4, -3]],

      [[3, -4, 3], [3, -4, 1], [3, -4, -1], [3, -4, -3],
        [1, -4, 3], [1, -4, 1], [1, -4, -1], [1, -4, -3],
        [-1, -4, 3], [-1, -4, 1], [-1, -4, 3], [-1, -4, -3],
        [-3, -4, 3], [-3, -4, 1], [-3, -4, -1], [-3, -4, -3]],

      [[-3, 3, -4], [-3, 1, -4], [-3, -1, -4], [-3, -3, -4],
        [-1, 3, -4], [-1, 1, -4], [-1, -1, -4], [-1, -3, -4],
        [1, 3, -4], [1, 1, -4], [1, -1, -4], [1, -3, -4],
        [3, 3, -4], [3, 1, -4], [3, -1, -4], [3, -3, -4]],

      [[3, 3, 4], [3, 1, 4], [3, -1, 4], [3, -3, 4],
        [1, 3, 4], [1, 1, 4], [1, -1, 4], [1, 3, 4],
        [-1, 3, 4], [-1, 1, 4], [-1, -1, 4], [-1, -3, 4],
        [-3, 3, 4], [-3, 1, 4], [-3, -1, 4], [-3, -3, 4]]
    ]
    this.faceLoad = Array(6).fill(false)
    this.cubeFace1kLoad = Array(6).fill(null).map(() => Array(4).fill(false))// 立方体每个面4张照片的中心
    this.randered2k = Array(6).fill(null).map(() => Array(4).fill(false))// 立方体每个面4张照片的中心
    this.cubeFace2kLoad = Array(6).fill(null).map(() => Array(16).fill(false))// 立方体每个面16张照片的中心

    this.faceLoadCount1k = Array(6).fill(0)
    this.faceLoadCount2k = Array(6).fill(0)

    this.target1k = new THREE.WebGLCubeRenderTarget(2048, { format: THREE.RGBFormat, generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter, encoding: THREE.sRGBEncoding, depthBuffer: false })
    this.targetLast = new THREE.WebGLCubeRenderTarget(2048, { format: THREE.RGBFormat, generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter, encoding: THREE.sRGBEncoding, depthBuffer: false })
    // this.target2k = new THREE.WebGLCubeRenderTarget(2048, { format: THREE.RGBFormat, generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter, encoding: THREE.sRGBEncoding })

    // console.log(this.textureLast instanceof THREE.CubeTexture)

    this.texture1kInit = false
    this.texture2kInit = false

    this.camDir = new THREE.Vector3(0, 0, 0)
    this.camFov = 1.0
    this.camPosIndex = 0

    this.material = this.newCubeMaterial()
  }

  sendMaterial (objs) {
    toMaterial(objs, this.material)
  }

  initRenderer (renderer) {
    this.textureRender = new CubeRenderManager(renderer)
  }

  /**
   * 新建模型材质，初始位置为0
   * @returns
   * @memberof Material
   */
  newCubeMaterial () {
    const VSHEADER_SOURCE =
    'uniform mat4 lastCorrect;\n' +
    'uniform mat4 correct;\n' +
    'uniform vec3 pos;\n' +
    'uniform bool changeDone;' +
    'varying vec3 v_texCoord;\n' +
    'varying vec3 v_texCoordLast;' +
    'void main(void){\n' +
        'vec4 worldPosition=modelMatrix*vec4(position,1.);\n' +
        'v_texCoord =(correct*worldPosition).xyz;\n' +
        'v_texCoordLast =(lastCorrect*worldPosition).xyz;\n' +
        'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n' +
        '}'

    const FSHEADER_SOURCE =
    'uniform samplerCube texture1k;' +
    // 'uniform samplerCube texture2k;' +
    'uniform samplerCube textureLast;' +
    'uniform bool changeDone;' +
    'uniform float fovscale;' +
    'uniform float alphaNow;' +
    'varying vec3 v_texCoord;' +
    'varying vec3 v_texCoordLast;' +
    'void main(void)' +
    '{' +
     'vec3 v_texCoord_nor=normalize(vec3(v_texCoord.x,v_texCoord.y,-v_texCoord.z));' +
      'vec4 color1k=textureCube(texture1k, v_texCoord_nor);' +
      'if(changeDone){' +
        'gl_FragColor=color1k;' +
      '}' +
      'else{' +
        'vec3 v_texCoord_norLast=normalize(vec3(v_texCoordLast.x,v_texCoordLast.y,-v_texCoordLast.z));' +
        'vec4 colorLast=textureCube(textureLast, v_texCoord_norLast);' +
        'gl_FragColor=(1.0-alphaNow)*colorLast+(alphaNow)*color1k;' +
      '}' +
    '}'

    this.texture1kInit = false
    // this.texture2kInit = false

    this.uniforms = {
      texture1k: { value: this.target1k.texture },
      // texture2k: { value: this.target2k.texture },
      textureLast: { value: this.targetLast.texture },
      changeDone: { value: true },
      alphaNow: { value: 1.0 },
      fovscale: { value: 1.0 },
      lastCorrect: { value: new THREE.Matrix4() },
      correct: { value: new THREE.Matrix4() },
      pos: { value: [0.0, 0.0, 0.0] } // 模型位置
    }

    this.rotateMat = new THREE.Matrix4()

    const material = new THREE.ShaderMaterial({
      uniforms: this.uniforms,
      vertexShader: VSHEADER_SOURCE,
      fragmentShader: FSHEADER_SOURCE,
      side: THREE.DoubleSide
    })
    return material
  }

  /**
   *
   * @param {THREE.Matrix4} mat 旋转矩阵
   */
  markCurrectRotation (mat) {
    this.rotateMat.extractRotation(mat)
  }

  /**
   * 初始化位置
   *
   * @param {number} idx 目标位置下标
   * @param {THREE.Matrix4} correction 目标相机点位旋转矫正
   * @memberof Material
   */
  init (idx, correction) {
    this.camPosIndex = idx
    this.markCurrectRotation(correction)
    this.uniforms.correct.value = correction
    this.uniforms.lastCorrect.value = correction
    // 立方体纹理贴图
    const self = this
    this.textureMgr.targetLoad512(idx)
      .then(cpi => {
        self.setTexture(cpi)
        self.texture1kInit = true
        self.texture2kInit = true
      })
  }

  /**
   * 直接设置贴图，
   */
  newTextureDone () {
    this.uniforms.changeDone.value = true
    this.uniforms.alphaNow.value = 1
  }

  /**
   * 准备贴图变换
   */
  async prepareForTranslate (targetIdx, correction) {
    let readly = false
    let uiFlag = false
    const self = this
    return new Promise((resolve, reject) => {
      self.setNewTexture(targetIdx, correction).then(() => {
        readly = true
        if (uiFlag) {
          document.getElementById('waiting-texture').style.display = 'none'
        }
        resolve()
      }, reason => {
        console.error('加载贴图失败，请查看网络设置')
        readly = true
        if (uiFlag) {
          document.getElementById('waiting-texture').style.display = 'none'
        }
        reject(reason)
      })
      setTimeout(() => {
        if (readly) return
        uiFlag = true
        document.getElementById('waiting-texture').style.display = 'flex'
      }, config.Material.WaitForLoadDelay)
    })
  }

  /**
   * 设置当前贴图
   * @param {number} targetIdx 目标点位下标
   * @param {THREE.Matrix4} correction 目标变化矩阵
   */
  async setNewTexture (targetIdx, correction, immediately = false) {
    if (this.camPosIndex === targetIdx) {
      return
    }
    this.camPosIndex = targetIdx
    const self = this
    await this.textureMgr.targetLoad512(targetIdx).then(
      cpi => {
        self.markCurrectRotation(correction)
        this.swapTexture(correction)

        self.uniforms.changeDone.value = immediately
        self.uniforms.alphaNow.value = immediately ? 1 : 0
        for (let i = 0; i < 6; ++i) {
          this.faceLoad[i] = false// 重新加载6
          for (let j = 0; j < 4; ++j) {
            this.cubeFace1kLoad[i][j] = false
            this.randered2k[i][j] = false
          }
          for (let j = 0; j < 16; ++j) {
            this.cubeFace2kLoad[i][j] = false
          }
        }

        self.setTexture(cpi)
      }
    )
  }

  swapTexture (correction) {
    this.uniforms.lastCorrect.value = this.uniforms.correct.value
    this.uniforms.correct.value = correction

    const last = this.target1k
    const curr = this.targetLast
    this.target1k = curr
    this.targetLast = last

    this.uniforms.texture1k.value = curr.texture
    this.uniforms.textureLast.value = last.texture
  }

  /**
   * 动画跳转到位置
   *
   * @param {Nunber} newIndex 新位置下标
   * @param {THREE.Vector3} cpointPos 新坐标
   * @param {Number} transitionTime 动画时间
   * @param {THREE.Matrix4} correction 目标相机点位旋转矫正
   * @memberof Material
   */
  updateTexture (transitionTime) { // 更新相机位置更新贴图
    this.texAnimate(transitionTime) // 新位置动画
  }

  /**
   * 材质动画
   *
   * @param {Number} time 运行时间
   * @memberof Material
   */
  texAnimate (time) {
    this.uniforms.alphaNow.value = 0
    const a = {
      x: 0
    }
    this.route = new TWEEN.Tween(a)

    this.route.to({
      x: 1.0
    }, time)
    this.route.onUpdate(() => {
      this.uniforms.alphaNow.value = a.x
    })
    this.route.easing(TWEEN.Easing.Sinusoidal.InOut)
    this.route.onComplete(() => { // 动画完成
      this.uniforms.alphaNow.value = 1.0
      this.uniforms.changeDone.value = true
      this.uniforms.lastCorrect.value = this.uniforms.correct.value
    })
    this.route.start()
  }

  updateMaterialFov (scale) {
    this.camFov = scale
    this.uniforms.fovscale.value = scale
  }

  /**
   *
   * @param {THREE.Vector3} target 朝向位置
   * @param {THREE.Vector3} camPos 摄像机坐标
   * @param {CPointSet} cps 点位结合
   */
  async autoLoadCubeFace (target, camPos, cps) {
    const dir = target.clone().sub(camPos).normalize()
    this.textureMgr.autoLoad512(this.camPosIndex, dir, cps.CameraPoints)

    if ((!this.texture1kInit) || (!this.texture2kInit)) return
    this.camDir.copy(dir)
    this.camDir.applyMatrix4(this.rotateMat)

    for (let i = 0; i < 6; ++i) {
      if (this.faceLoad[i]) continue
      var faceDir = new THREE.Vector3(this.cubeFaceCenter512[i][0], this.cubeFaceCenter512[i][1], this.cubeFaceCenter512[i][2])
      var angle = THREE.MathUtils.radToDeg(this.camDir.angleTo(faceDir))// 面中心与相机夹角

      if (angle < 60) { // 可以看见这个面，进行加载
        const face4Load = [false, false, false, false]
        let count1 = 0
        for (let j = 0; j < 4; ++j) { // 这个面中4个块的哪几个块可以被看见
          if (this.cubeFace1kLoad[i][j]) continue// 已经加载了
          const faceDirj = new THREE.Vector3(this.cubeFaceCenter1k[i][j][0], this.cubeFaceCenter1k[i][j][1], this.cubeFaceCenter1k[i][j][2])
          const anglej = THREE.MathUtils.radToDeg(this.camDir.angleTo(faceDirj))// 面中心与相机夹角
          if (anglej < 60) {
            face4Load[j] = true
            this.cubeFace1kLoad[i][j] = true
            this.faceLoadCount1k[i]++
            count1++
          }
        }
        if (count1 > 0) this.autoLoadFace1kAsync(this.camPosIndex, i, face4Load)// 请求其中的几面进行拼接
        let count2 = 0
        const face96Load = [false, false, false, false,
          false, false, false, false,
          false, false, false, false,
          false, false, false, false]
        for (let j = 0; j < 16; ++j) { // 这个面中16个块的哪几个块可以被看见
          if (this.cubeFace2kLoad[i][j]) continue// 已经加载了
          const faceDirj = new THREE.Vector3(this.cubeFaceCenter2k[i][j][0], this.cubeFaceCenter2k[i][j][1], this.cubeFaceCenter2k[i][j][2])
          const anglej = THREE.MathUtils.radToDeg(this.camDir.angleTo(faceDirj))// 面中心与相机夹角
          if (anglej < 40) {
            face96Load[j] = true
            this.cubeFace2kLoad[i][j] = true
            this.faceLoadCount2k[i]++
            count2++
          }
        }
        if (count2 > 0) this.autoLoadFace2kAsync(this.camPosIndex, i, face96Load)
        if (this.faceLoadCount1k[i] === 4 && this.faceLoadCount2k[i] === 16) {
          this.faceLoad[i] = true
        }
      }
    }
  }

  /**
   * 设置贴图为点位贴图
   * @param {CameraPointImage} cpi 点位贴图信息
   */
  setTexture (cpi) {
    for (let i = 0; i < 6; ++i) {
      this.textureRender.renderImage(this.target1k, cpi.image512[i], i, 0, 0, 1)
      // this.textureRender.renderImage(this.target2k, cpi.image512[i], i, 0, 0, 1)
    }
  }

  async perload512 (idx) {
    return this.textureMgr.perload512(idx)
  }

  async autoLoadFace1kAsync (idx, n, faceLoadArr) {
    for (let i = 0; i < faceLoadArr.length; i++) {
      if (!faceLoadArr[i]) continue
      const currCpi = this.textureMgr.pointImages[idx]
      const idxI = Math.floor(i / 2)
      const idxJ = i % 2
      await currCpi.load1k(n, idxI, idxJ)
      if (idx !== this.camPosIndex) {
        return
      }
      if (currCpi.image1K[n][currCpi.ijTo1kIdx(idxI, idxJ)] &&
      !this.randered2k[n][i]) {
        this.textureRender.renderImage(this.target1k, currCpi.image1K[n][currCpi.ijTo1kIdx(idxI, idxJ)], n, idxI, idxJ, 2)
      }
    }
  }

  async autoLoadFace2kAsync (idx, n, faceLoadArr) {
    for (let i = 0; i < faceLoadArr.length; i++) {
      if (!faceLoadArr[i]) continue
      const currCpi = this.textureMgr.pointImages[idx]
      const idxI = Math.floor(i / 4)
      const idxJ = i % 4
      await currCpi.load2k(n, idxI, idxJ)
      if (idx !== this.camPosIndex) {
        return
      }
      if (currCpi.image2K[n][currCpi.ijTo2kIdx(idxI, idxJ)]) {
        this.randered2k[n][Math.floor(idxI / 2) * 2 + Math.floor(idxJ / 2)] = true
        this.textureRender.renderImage(this.target1k, currCpi.image2K[n][currCpi.ijTo2kIdx(idxI, idxJ)], n, idxI, idxJ, 4)
      }
    }
  }
}

export class GodMaterial {
  constructor () {
    this.name = 'GodMat_offscreen'
    this.materials = []
  }

  sendMaterial (objs) {
    for (let i = 0; i < objs.length; i++) {
      objs[i].material = this.materials[i]
    }
  }
}

/**
 * 更换场景物体为材质
 * @param {THREE.Object3D[]} objs 场景物体
 * @param {THREE.Material} material 场景物体
 */
export function toMaterial (objs, material) {
  for (const obj of objs) {
    obj.material = material
  }
}

export class CubeRenderManager {
  constructor (renderer) {
    this._renderer = renderer

    const VSHEADER_SOURCE = 'varying vec2 vUv;\n' +
      'void main(void){\n' +
      'vUv =vec2(uv.x,1.0-uv.y);\n' +
      'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n' +
      '}'

    const FSHEADER_SOURCE = 'uniform sampler2D _texture;' +
      'varying vec2 vUv;' +
      'void main(void)' +
      '{' +
      'gl_FragColor=texture2D(_texture, vUv);' +
      '}'

    this.scene = new THREE.Scene()
    this.scene.background = null

    this.renderCamera = new THREE.OrthographicCamera(-0.5, 0.5, 0.5, -0.5, -200, 200)
    this.scene.add(this.renderCamera)

    this.uniform2 = { _texture: { value: null } }

    const mat2 = new THREE.ShaderMaterial({
      uniforms: this.uniform2,
      vertexShader: VSHEADER_SOURCE,
      fragmentShader: FSHEADER_SOURCE,
      side: THREE.DoubleSide
    })
    this.plane = new THREE.Mesh(new THREE.PlaneBufferGeometry(1, 1), mat2)
    this.scene.add(this.plane)
  }

  /**
   *
   * @param {THREE.WebGLRenderer} render 渲染器
   * @param {Image} img 图片
   * @param {THREE.WebGLCubeRenderTarget} renderTarget 渲染目标
   * @param {number} tileXInRender 起始位置
   * @param {number} tileYInRender 结束位置
   * @param {number} tileSizeInRender 图片片段长度
   */

  renderImage (renderTarget, img, faceNum, xPos, yPos, type) {
    const l = 1.0 / type
    const posX = xPos * l + l / 2 - 0.5
    const posY = yPos * l + l / 2 - 0.5
    const width = l
    const height = l

    const texture2 = new THREE.Texture(img) // 绘制原来的
    texture2.needsUpdate = true // 下次使用纹理时触发更新
    this.plane.material.needsUpdate = true
    this.uniform2._texture.value = texture2
    this.plane.position.set(posX, posY, 1)
    this.plane.scale.set(width, height, 1)

    const tempClear = this._renderer.autoClear
    this._renderer.autoClear = false

    this._renderer.setRenderTarget(renderTarget, faceNum)
    this._renderer.render(this.scene, this.renderCamera)
    this._renderer.autoClear = tempClear
    this._renderer.setRenderTarget(null)

    this.uniform2._texture.value = null
    texture2.dispose()
  }
}

export {
  Material
}
